import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessReport extends ConnectBasicEntity {
body: string;
processCode: string;
recipients: string;
status: string;
title: string;
visionCode: string;
}

